// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.css
// module id = 2768
// module chunks = 0